export default "<template>\r\n  <v-text-field color=\"success\" loading disabled></v-text-field>\r\n</template>\r\n";